import { render, staticRenderFns } from "./FacePanel.vue?vue&type=template&id=d493b1e0&scoped=true&"
import script from "./FacePanel.vue?vue&type=script&lang=js&"
export * from "./FacePanel.vue?vue&type=script&lang=js&"
import style0 from "./FacePanel.vue?vue&type=style&index=0&id=d493b1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d493b1e0",
  null
  
)

export default component.exports